
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zhuanti/[alias]",
      function () {
        return require("private-next-pages/zhuanti/[alias].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zhuanti/[alias]"])
      });
    }
  